import { ClientPortfolioType } from '../redux/reducers/clients'

type ExchangeRateFn = (from: string, to: string, amount: number, rates: any) => number

// Soucty klienta pres vsechna portfolia v CZK. amount obsahuje i hotovost.
const clientTotalsCzk = (portfolios: ClientPortfolioType[], exchangeRate: ExchangeRateFn, rates: any) => {
  let totalCzk = 0
  let balanceCzk = 0
  portfolios.forEach(p => {
    totalCzk += exchangeRate(p.currency, 'CZK', p.amount || 0, rates)
    balanceCzk += exchangeRate(p.currency, 'CZK', p.accountsBalance || 0, rates)
  })
  return { totalCzk, balanceCzk, securitiesCzk: totalCzk - balanceCzk }
}

// LTV klienta: dluh (zaporna hotovost) / hodnota CP.
// Stejny vzorec jako na detailu klienta (PortfolioHeroCard).
export const computeClientLtv = (portfolios: ClientPortfolioType[], exchangeRate: ExchangeRateFn, rates: any): number => {
  const { balanceCzk, securitiesCzk } = clientTotalsCzk(portfolios, exchangeRate, rates)
  if (balanceCzk >= 0 || securitiesCzk <= 0) return 0
  return -balanceCzk / securitiesCzk
}

// Vyse uveru klienta v CZK (= LTV x hodnota CP).
export const computeClientDebtCzk = (portfolios: ClientPortfolioType[], exchangeRate: ExchangeRateFn, rates: any): number => {
  const { balanceCzk } = clientTotalsCzk(portfolios, exchangeRate, rates)
  return balanceCzk < 0 ? -balanceCzk : 0
}

// Kolik vlastnich prostredku musi klient vlozit (splatit dluh), aby LTV kleslo na cil.
// Vklad snizuje dluh, hodnota CP se nemeni: dluh - x = cil * CP => x = dluh - cil * CP.
// Pod cilovym LTV vraci 0.
export const ltvTopUpToTarget = (debt: number, securities: number, target: number): number =>
  Math.max(0, debt - target * Math.max(0, securities))

export const computeClientLtvTopUpCzk = (
  portfolios: ClientPortfolioType[],
  exchangeRate: ExchangeRateFn,
  rates: any,
  target: number
): number => {
  const { balanceCzk, securitiesCzk } = clientTotalsCzk(portfolios, exchangeRate, rates)
  return ltvTopUpToTarget(balanceCzk < 0 ? -balanceCzk : 0, securitiesCzk, target)
}
